export default __webpack_public_path__ + "static/cruiselines-vrc-places-2-466f40ac9b171621f7f02afdbb2e596e.jpg";